import { render, staticRenderFns } from "./editPlanMantainOrder.vue?vue&type=template&id=4bc6f0c1&scoped=true&"
import script from "./editPlanMantainOrder.vue?vue&type=script&lang=js&"
export * from "./editPlanMantainOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6f0c1",
  null
  
)

export default component.exports